/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Contact controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetContactByIdResponse, UpdateContactRequest, CustomerState, GetContactsResponse, CreateContactRequest, CreateContactResponse } from "../models";

@Injectable({ providedIn: "root" })
export class ContactService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getContactById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetContactByIdResponse>;
    getContactById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetContactByIdResponse>>;
    getContactById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetContactByIdResponse>>;
    getContactById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Contact/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateContact(id: number, updateContactRequest: UpdateContactRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateContact(id: number, updateContactRequest: UpdateContactRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateContact(id: number, updateContactRequest: UpdateContactRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateContact(id: number, updateContactRequest: UpdateContactRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Contact/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateContactRequest, requestOptions);
    }

    deleteContact(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteContact(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteContact(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteContact(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Contact/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getContacts(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetContactsResponse>;
    getContacts(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetContactsResponse>>;
    getContacts(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetContactsResponse>>;
    getContacts(searchTerm?: string | null, states?: (Array<CustomerState> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Contact`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (states != null) {
            params = HttpParamsBuilder.addToHttpParams(params, states, 'states');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createContact(createContactRequest: CreateContactRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateContactResponse>;
    createContact(createContactRequest: CreateContactRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateContactResponse>>;
    createContact(createContactRequest: CreateContactRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateContactResponse>>;
    createContact(createContactRequest: CreateContactRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Contact`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createContactRequest, requestOptions);
    }
}
